module.exports = __webpack_public_path__ + "static/media/shape1_4.53547b7b.obj";